import http from '../../services/http'
import { ILimits } from '../limits'

const url = 'api/recordings'

export const saveRecordings = async (payload: any): Promise<ILimits> => {
  const response = await http.post(url, payload)
  return response.data
}
